import callAPI from '../ApiConfig'

const getAccounts = async (props) => {
    return await callAPI({
        route: "accounts/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const addAccount = async (props) => {
    return await callAPI({
        route: "accounts/",
        method: "post",
        data: props?.data,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const editAccount = async (props) => {
    return await callAPI({
        route: `accounts/${props?.id}`,
        method: "put",
        data: props?.data,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const deleteAccount = async (props) => {
    return await callAPI({
        route: `accounts/${props?.id}`,
        method: "delete",
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const accountAPI = {
    getAccounts: getAccounts,
    addAccount: addAccount,
    editAccount: editAccount,
    deleteAccount: deleteAccount
}

export default accountAPI
